<template>
    <div>
        <annual-leave-status-list></annual-leave-status-list>
    </div>
    </template>
    
    <script>
    export default {}
    </script>
    